var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgWave4Inverted = function SvgWave4Inverted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1610 208.9V79.2s-81.4 33.3-241.4 23.1c-157.4-10-247.9-49.6-340.9-49.4-93.1.1-121 14.6-174.2 33.6-75.7 27.1-166.9 27.2-185.5 25.1-18.7-2.1-67.8-5.5-106 19.3-38.2 24.7-94.8 55.4-209.2 43.1C238.1 161.4 80 125.9-10 182v26.9h1620z"
  })));
};
export default SvgWave4Inverted;